import appstore from "/src/assets/appstore.webp"
import playstore from "/src/assets/googleplay.webp"
import { Fragment } from "react"
export const dlAppData = [
  {
    key: "ios",
    img: appstore,
    href: "https://short.storellet.com/VwLyI1",
  },
  {
    key: "android",
    img: playstore,
    href: "https://short.storellet.com/Vdh3EQ",
  },
]
export const renderDLAPP = ({
  onClick,
  centered = false,
}: {
  onClick: (arg0: string) => void
  centered?: boolean
}) => {
  return (
    <div
      className={clsx(
        {
          "justify-center": centered,
        },
        "flex flex-row",
      )}
    >
      {dlAppData.map((f) => (
        <Fragment key={`footer-dl-${f.key}`}>
          <a
            className={clsx("my-1 mx-2")}
            target="_bl"
            href={f.href}
            onClick={() => onClick(f.key)}
          >
            <img src={f.img} className="h-12" />
          </a>
        </Fragment>
      ))}
    </div>
  )
}
